{
  "nav": {
    "chat": "Sessão",
    "agents": "Agentes",
    "history": "Histórico",
    "files": "Arquivos",
    "changes": "Alterações",
    "mailbox": "Caixa de entrada",
    "skills": "Skills",
    "worktrees": "Worktrees",
    "design": "Design Studio",
    "officemap": "Mapa de escritórios",
    "settings": "Configurações",
    "sddwizard": "Novo projeto SDD",
    "specs": "Specs",
    "sddboard": "Painel ao vivo",
    "autophase": "Fases",
    "fleet": "Frota",
    "inspector": "Inspetor",
    "prompts": "Prompts"
  },
  "brand": {
    "returnToChat": "{{name}} — voltar ao chat",
    "returnToChatDefault": "WrongStack — voltar ao chat"
  },
  "status": {
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "idle": "Ocioso",
    "thinking": "Pensando",
    "running": "Executando",
    "waiting": "Aguardando",
    "done": "Concluído",
    "stopped": "Parado"
  },
  "menu": {
    "moreWithHidden": "Mais, {{count}} itens ocultos",
    "moreOptions": "Mais opções",
    "moreCompactHidden": "Mais — {{count}} painéis/visualizações ocultos, paleta, tema, monitores",
    "moreCompact": "Mais — paleta, tema, monitores",
    "moreFull": "Mais — paleta, tema, atalhos, monitores",
    "commandPalette": "Paleta de comandos",
    "keyboardShortcuts": "Atalhos do teclado",
    "panels": "Painéis",
    "views": "Visualizações",
    "theme": "Tema",
    "monitors": "Monitores",
    "fleetMonitor": "Monitor da frota",
    "agentsMonitor": "Monitor de agentes"
  },
  "sidePanel": {
    "dragHint": "Arraste para redimensionar · duplo clique para redefinir",
    "collapse": "Recolher painel (Ctrl+\\)"
  },
  "history": {
    "openDashboard": "Abrir painel de sessões"
  },
  "agents": {
    "pending": "pendentes…",
    "empty": "Nenhum agente ainda",
    "emptyHint": "Subagentes aparecem aqui quando a frota está ativa.",
    "runningCount": "{{count}} em execução",
    "totalCount": "{{count}} no total",
    "openFull": "Abrir visualização completa de agentes",
    "agentsLive": "AGENTES · LIVE",
    "doneCount": "{{count}} concluídos",
    "failedCount": "{{count}} falhas",
    "modelsLabel": "modelos",
    "shownLabel": "exibidos",
    "totalLabel": "total",
    "leaderFleetTotals": "(líder {{leader}} · frota {{fleet}})",
    "navHintJk": "j/k ou ↑↓ para navegar",
    "escCloseDetail": "· Esc para fechar o detalhe",
    "noAgentsRunning": "Sem agentes em execução.",
    "contextUsage": "Uso de contexto",
    "lastToolLabel": "último:",
    "unknownSession": "Sessão desconhecida",
    "sessionCopyTitle": "Sessão: {{sid}} — clique para copiar",
    "sessionWord": "sessão",
    "agentsCountSuffix_one": "{{count}} agente",
    "agentsCountSuffix_other": "{{count}} agentes",
    "sessionTitle": "Sessão: {{sid}}",
    "projectSuffix": " · Projeto: {{name}}",
    "statusIdle": "inativo"
  },
  "changes": {
    "fileCount_one": "{{count}} arquivo",
    "fileCount_other": "{{count}} arquivos",
    "refreshTitle": "Atualizar alterações",
    "loading": "Carregando alterações…",
    "clean": "Sem alterações — a árvore de trabalho está limpa.",
    "selectPrompt": "Selecione um arquivo alterado para ver seu diff.",
    "unified": "Unificado",
    "unifiedTitle": "Diff unificado",
    "edit": "Editar",
    "editTitle": "Diff lado a lado editável",
    "loadingDiff": "Carregando diff…",
    "binary": "Arquivo binário — diff não mostrado.",
    "tooLarge": "Arquivo grande demais para diff."
  },
  "inspector": {
    "showPanel": "Mostrar painel Inspetor (Frota / Agentes / Auditoria)",
    "hidePanel": "Ocultar painel Inspetor",
    "label": "Inspetor",
    "openAudit": "Abrir aba Auditoria",
    "tabFleet": "Frota",
    "tabAgents": "Agentes",
    "tabAudit": "Auditoria",
    "collapseAria": "Recolher painel Inspetor",
    "collapseTitle": "Recolher (Esc)",
    "noAgentsActive": "Nenhum agente ativo",
    "agentsAppearHint": "Os agentes aparecem aqui quando a frota está ativa.",
    "selected": "{{name}} (selecionado)"
  },
  "nextSteps": {
    "header": "Próximos passos",
    "autoSubmitting": "envio automático em",
    "clickToFill": "clique para preencher",
    "clickToFillTitle": "Clique para preencher: {{text}}",
    "auto": "auto",
    "willAutoSubmit": "Envio automático após a contagem regressiva"
  },
  "mailbox": {
    "onlineCount": "{{count}} online",
    "messages": "Mensagens",
    "deleteAllTitle": "Excluir todas as mensagens",
    "deleteAll": "Excluir tudo",
    "deleting": "Excluindo…",
    "purgeTitle": "Purgar mensagens obsoletas/órfãs",
    "purge": "Purgar",
    "purging": "Purgando…",
    "newLabel": "NOVO",
    "empty": "Nenhuma mensagem ainda.",
    "offlineCount": "+{{count}} offline",
    "timeNow": "agora",
    "deleteAllConfirmTitle_one": "Excluir {{count}} mensagem?",
    "deleteAllConfirmTitle_other": "Excluir todas as {{count}} mensagens?",
    "deleteAllConfirmBody": "O arquivo da caixa de entrada é truncado para cada agente. Isso não pode ser desfeito.",
    "purgeConfirmTitle": "Purgar mensagens obsoletas?",
    "purgeConfirmBody": "Remove mensagens concluídas com mais de 1 dia e mensagens incompletas com mais de 7 dias. Mensagens ativas são preservadas.",
    "type": {
      "note": "Nota",
      "ask": "Pergunta",
      "assign": "Atribuição",
      "steer": "Direcionar",
      "btw": "A propósito",
      "broadcast": "Transmissão",
      "status": "Status",
      "result": "Resultado"
    },
    "emptyDetail": "Nenhuma mensagem selecionada",
    "emptyDetailHint": "Clique em uma mensagem no painel Caixa de entrada para vê-la aqui.",
    "readBy": "Lido por",
    "backToChat": "Voltar ao chat",
    "completed": "Concluído",
    "everyone": "todos",
    "closeTitle": "Fechar (Esc)",
    "replyTo": "Em resposta a: {{id}}",
    "completedBy": "Concluído por {{name}}",
    "completedByAt": "Concluído por {{name}} em {{time}}",
    "outcome": "Resultado:",
    "task": "Tarefa:",
    "messageNotFound": "Mensagem não encontrada",
    "messageNotFoundHint": "Esta mensagem pode ter sido excluída ou removida."
  },
  "sessions": {
    "recentSessions": "Sessões recentes",
    "deleteEmptyTitle_one": "Excluir {{count}} sessão vazia?",
    "deleteEmptyTitle_other": "Excluir {{count}} sessões vazias?",
    "deleteEmptyConfirmBody": "Sessões sem uso de tokens são removidas do disco.",
    "filterPlaceholder": "Filtrar por título, modelo, provedor…",
    "clearFilter": "Limpar filtro",
    "noHistory": "Nenhum histórico ainda",
    "noHistoryHint": "Suas conversas aparecerão aqui",
    "noMatches": "Nenhum resultado",
    "noMatchesHint": "Tente um filtro diferente",
    "group": {
      "favorites": "Favoritos",
      "today": "Hoje",
      "yesterday": "Ontem",
      "thisWeek": "Esta semana",
      "earlier": "Anteriores"
    },
    "nicknamePlaceholder": "Apelido",
    "empty": "(vazio)",
    "resuming": "retomando…",
    "active": "ativa",
    "renameTitleNickname": "{{nickname}} — original: {{title}}",
    "renameTitle": "{{title}}\n\nClique duas vezes para renomear",
    "unfavorite": "Remover dos favoritos",
    "markFavorite": "Marcar como favorito",
    "deleteSessionConfirmTitle": "Excluir a sessão?",
    "deleteSessionConfirmBody": "\"{{name}}\" será removida do disco. Isso não pode ser desfeito.",
    "deleteSessionTitle": "Excluir sessão"
  },
  "sessionPanel": {
    "actions": {
      "abort": "Interromper",
      "newSession": "Nova sessão",
      "export": "Exportar",
      "compact": "Compactar",
      "newSessionTitle": "Iniciar uma nova sessão (Ctrl+N)",
      "exportTitle": "Exportar o chat como markdown (Ctrl+E)",
      "compactTitle": "Compactar a janela de contexto",
      "clearTitle": "Limpar o contexto (Ctrl+L)"
    },
    "model": "Modelo",
    "modelTitle": "Trocar de modelo (Ctrl+M)",
    "context": "Contexto",
    "contextTitle": "Clique para um detalhamento do contexto",
    "sessionLabel": "Sessão",
    "stats": {
      "messages": "Mensagens",
      "elapsed": "Decorrido",
      "tokens": "Tokens",
      "cost": "Custo",
      "iteration": "Iteração",
      "agents": "Agentes",
      "tokensSub": "{{in}} entra / {{out}} sai",
      "iterationOf": "de {{max}}",
      "agentsRunning": "{{count}} em execução"
    },
    "plan": "Plano",
    "planComplete": "{{pct}}% concluído",
    "pinned": "Fixados",
    "quickSettings": "Ajustes rápidos",
    "autonomy": "Autonomia",
    "autonomyOptions": {
      "off": "Desativado",
      "suggest": "Sugerir",
      "auto": "Auto",
      "eternal": "Perpétuo",
      "eternal-parallel": "Perpétuo Paralelo"
    },
    "yolo": "Modo YOLO",
    "yoloTitle": "Ignorar os diálogos de confirmação de ferramentas",
    "refine": "Refinar prompts",
    "refineTitle": "Reescrever os prompts antes de enviar",
    "sound": "Som ao concluir",
    "soundTitle": "Tocar um leve som ao terminar uma execução",
    "sessionId": "sessão {{id}}"
  },
  "fleet": {
    "status": {
      "running": "em execução",
      "done": "concluído",
      "failed": "falhou",
      "timeout": "tempo esgotado",
      "stopped": "parado"
    },
    "leader": "líder",
    "providerModel": "Provedor / Modelo",
    "elapsed": "Decorrido",
    "running": "em execução…",
    "iterations": "Iterações",
    "toolCalls": "Chamadas",
    "cost": "Custo",
    "budgetExtensions": "Extensões de orçamento",
    "activity": "Atividade",
    "budgetWarning": "aviso de orçamento",
    "contextWindow": "Janela de contexto",
    "tokensUsed": "{{used}} / {{max}} tokens",
    "toolRunning": "em execução…",
    "lastTool": "última ferramenta",
    "error": "Erro",
    "finalOutput": "Saída final",
    "copyOutput": "Copiar saída",
    "liveOutput": "Saída ao vivo",
    "waitingOutput": "Aguardando saída…",
    "outputHint": "A saída aparece aqui conforme o agente transmite o texto.",
    "toolLog": "Registro de ferramentas ({{count}} chamadas)",
    "fail": "falha",
    "moreTools": "+{{count}} ferramentas a mais",
    "cardRunning": "em execução {{tool}}",
    "cardLastTool": "última: {{tool}}",
    "contextPercent": "Contexto {{pct}}%",
    "doneCount": "{{count}} concluídos",
    "errCount": "{{count}} err",
    "statusRunning": "em execução",
    "statusDone": "concluído",
    "statusFailed": "falhou",
    "statusTimeout": "tempo esgotado",
    "statusStopped": "parado",
    "sessionPrefix": "sessão:",
    "currentTask": "Tarefa atual",
    "performance": "Desempenho",
    "uniqueTools": "Ferramentas únicas",
    "avgPerTool": "média {{ms}}ms por ferramenta",
    "context": "Contexto",
    "tokens": "Tokens",
    "ctxUsed": "{{pct}}% usado",
    "completed": "concluído",
    "budgetWarningTitle": "⚡ Aviso de orçamento",
    "hittingLimit": "Atinge o limite {{kind}} ({{used}}/{{limit}})",
    "hittingLimitTitle": "⚡ atinge o limite {{kind}} ({{used}}/{{limit}})",
    "budgetExt_one": "{{count}} extensão de orçamento",
    "budgetExt_other": "{{count}} extensões de orçamento",
    "extendedTimes_one": "O agente estendeu seu orçamento {{count}} vez por tarefas longas",
    "extendedTimes_other": "O agente estendeu seu orçamento {{count}} vezes por tarefas longas",
    "errorLabel": "Erro",
    "failureReason": "Motivo da falha",
    "failed": "Falhou",
    "fleetMonitor": "MONITOR DE FROTA",
    "runningCount": "{{count}} em execução",
    "totalAgents_one": "{{count}} agente no total",
    "totalAgents_other": "{{count}} agentes no total",
    "noLeader": "sem líder",
    "closeFleet": "Fechar monitor de frota",
    "colName": "Nome",
    "colStatus": "Status",
    "colActivity": "Atividade",
    "colIters": "Iter.",
    "colTools": "Ferram.",
    "colCost": "Custo",
    "colCtx": "CTX",
    "colExt": "Ext.",
    "colReason": "Motivo",
    "noAgentsActive": "Sem agentes ativos",
    "agentsAppear": "Os agentes aparecem aqui quando a frota está ativa.",
    "agentTimeline": "Linha do tempo de agentes",
    "noAgentEvents": "Ainda não há eventos de conversação de agentes.",
    "navHint": "↑↓ navegar",
    "selectDetailHint": "↵ selecionar detalhe",
    "escHint": "Esc desmarcar / fechar",
    "detailedView": "vista detalhada",
    "closeBtn": "✕ fechar",
    "selectAgentDetail": "Selecione um agente para informações detalhadas",
    "selectAgentBody": "Clique num agente da lista para métricas detalhadas, registros, saída em streaming e mais — similar à vista detalhada do histórico.",
    "navigateWord": "navegar",
    "selectWord": "selecionar",
    "deselectWord": "desmarcar"
  },
  "context": {
    "wsNotConnected": "WebSocket não conectado",
    "noData": "Nenhum dado de depuração recebido. O servidor pode não oferecer suporte à depuração de contexto.",
    "title": "Detalhamento do contexto",
    "windowUsage": "Uso da janela",
    "contextMode": "Modo de contexto",
    "fetching": "Buscando o detalhamento do contexto…",
    "systemPrompt": "Prompt do sistema",
    "tools": "Ferramentas",
    "messages": "Mensagens",
    "tokenAllocation": "Alocação de tokens",
    "systemTitle": "Sistema: {{tokens}}",
    "toolsTitle": "Ferramentas: {{tokens}}",
    "messagesTitle": "Mensagens: {{tokens}}",
    "system": "Sistema",
    "toolBreakdown": "Detalhamento de ferramentas",
    "messagesSummary": "Mensagens ({{count}}) — {{total}} tok",
    "barWithTokens": "Janela de contexto: {{tokens}} / {{max}} tokens ({{pct}})",
    "barPct": "Janela de contexto: {{pct}}",
    "barClick": " — clique para o detalhamento"
  },
  "refine": {
    "header": "✨ Refinar prompt",
    "autoSend": "envio automático em {{count}} s",
    "cancelTitle": "Cancelar (Esc)",
    "editLabel": "Editar o prompt refinado:",
    "editPlaceholder": "Editar o prompt refinado...",
    "useEdit": "Usar edição",
    "original": "Original",
    "refined": "Refinado",
    "yourLanguage": "(seu idioma)",
    "refinedTitle": "Clique ou pressione Enter para usar esta versão",
    "english": "Inglês",
    "englishTitle": "Pressione e para a versão em inglês",
    "hintRefined": "refinado",
    "hintEnglish": "Inglês",
    "hintOriginal": "original",
    "hintEdit": "editar",
    "edit": "Editar",
    "useRefined": "Usar refinado"
  },
  "specs": {
    "heading": "Especificações",
    "subtitle": "Ver e gerenciar o desenvolvimento orientado por especificações",
    "empty": "Nenhuma spec encontrada. Use {{command}} para criar uma.",
    "tasks": "Tarefas ({{count}})",
    "doneCount": "{{count}} concluídas",
    "runningCount": "{{count}} em execução",
    "pendingCount": "{{count}} pendentes",
    "runTitle": "Executar esta spec como um painel AutoPhase ao vivo",
    "run": "Executar",
    "list": "Lista",
    "graph": "Grafo",
    "loadingTasks": "Carregando tarefas…"
  },
  "refresh": {
    "heading": "Verificador de resiliência F5",
    "subtitle": "Confirma que a última sessão ativa, a transcrição e o estado da UI sobrevivem a um atualizar de página. Abra esta vista e pressione F5 — cada linha verde deve continuar verde.",
    "recordProbe": "Registrar sonda",
    "latestSession": "Última sessão ativa",
    "restoredLocal": "Restaurado do localStorage",
    "sessionIdExtra": "id da sessão: {{id}}",
    "noSessionYet": "nenhuma sessão foi iniciada ainda",
    "activePointer": "Ponteiro de sessão ativa",
    "lastVisited": "carimbo de tempo lastVisitedAt",
    "never": "nunca",
    "persistedEnv": "Ambiente persistido",
    "transcriptRehydrate": "Reidratação da transcrição",
    "localTranscript": "Transcrição local recuperada",
    "messagesExtra": "{{count}} mensagens, {{queued}} na fila",
    "noMessages": "0 mensagens",
    "noBleed": "Sem vazamento entre sessões",
    "bleedExtra": "ligado={{bound}} vs ativo={{active}}",
    "transcriptBinds": "a transcrição se liga à sessão ativa",
    "uiWorkspace": "Espaço de trabalho UI",
    "noneValue": "(nenhum)",
    "payloadSize": "Carga do localStorage (4 chaves): {{count}} caracteres",
    "probeLog": "Registro de sondas",
    "noProbes": "Nenhuma sonda ainda — pressione o botão \"Registrar sonda\" no topo, ou F5 nesta vista, para registrar uma verificação de reidratação.",
    "simulatedF5": "F5 simulado: reexecutar persist rehydrate"
  },
  "board": {
    "status": {
      "pending": "Pendente",
      "in_progress": "Em progresso",
      "review": "Revisão",
      "failed": "Falhou",
      "completed": "Concluído",
      "queued": "Em fila",
      "blocked": "Bloqueado",
      "cancelled": "Cancelado"
    },
    "newTaskTitle": "Nova tarefa",
    "newTaskPlaceholder": "Título da tarefa…",
    "addTask": "Adicionar tarefa",
    "empty": "Ainda não há fases — inicie uma execução AutoPhase para preencher o painel.",
    "summary": "{{phases}} fases · {{tasks}} tarefas",
    "phases": "Fases",
    "statusTab": "Status",
    "dropHere": "Solte as tarefas aqui",
    "emptySpec": "Ainda não há tarefas nesta spec.",
    "depGraphHeading": "Grafo de dependências",
    "worktreePrefix": "worktree: {{branch}}"
  },
  "debug": {
    "trendUp": "Aumentando",
    "trendDown": "Diminuindo",
    "trendStable": "Estável",
    "heading": "Painel de depuração",
    "subtitle": "Monitoramento em tempo real para WrongStack WebUI",
    "refreshLabel": "Atualizar:",
    "lastUpdated": "Última atualização: {{time}}",
    "fetchFailed": "Falha ao buscar métricas",
    "fileWatcher": "Observador de arquivos",
    "watcherStatus": "Status do observador",
    "running": "Em execução",
    "stopped": "Parado",
    "activeProjects": "Projetos ativos",
    "projectsWatched": "Projetos observados",
    "fileChanges": "Mudanças de arquivos",
    "totalDetected": "Total detectado",
    "filesProcessed": "Arquivos processados",
    "afterHash": "Após filtro de hash",
    "broadcastsSent": "Transmissões enviadas",
    "toClients": "Aos clientes WebUI",
    "debounceResets": "Reinícios de debounce",
    "rapidWrites": "Escritas rápidas sucessivas",
    "avgDebounce": "Atraso médio de debounce",
    "actualDelay": "Atraso real aplicado",
    "totalDelay": "Atraso total",
    "sumDelays": "Soma de todos os atrasos",
    "browserPerf": "Desempenho do navegador",
    "heapUsed": "Heap usado",
    "jsHeap": "Heap JavaScript",
    "heapTotal": "Heap total",
    "totalHeap": "Tamanho total do heap",
    "pageUptime": "Tempo de atividade da página",
    "sinceLoad": "Desde o carregamento",
    "rawData": "Dados brutos"
  },
  "providerModels": {
    "using": "Em uso",
    "noModelPicked": "(nenhum modelo escolhido)",
    "clearAllowlist": "Limpar lista permitida",
    "clearAllowlistAria": "Limpar a lista permitida salva para {{provider}}",
    "refresh": "Atualizar do servidor",
    "refreshAria": "Atualizar a lista de modelos para {{provider}}",
    "probing": "Verificando…",
    "use": "Usar",
    "useModelAria": "Usar o modelo {{model}} para {{provider}}",
    "differsHint": "A lista verificada difere da lista salva — execute {{command}} novamente para persistir."
  },
  "dock": {
    "expandChip": "Expandir {{label}}",
    "collapseChip": "Recolher {{label}}",
    "ahead": "{{count}} à frente",
    "behind": "{{count}} atrás",
    "linesAdded": "{{count}} linhas adicionadas",
    "linesDeleted": "{{count}} linhas excluídas",
    "untrackedFiles": "{{count}} arquivos não rastreados",
    "customizeTitle": "Personalizar chips do dock",
    "dockChips": "Chips do dock",
    "noActiveGoal": "Nenhum objetivo ativo",
    "noActiveGoalDetail": "Inicie um objetivo pelo chat ou pelo comando goal."
  },
  "agentsMonitor": {
    "leaderBadge": "LÍDER",
    "iters": "Iter.",
    "tools": "Ferramentas",
    "activityBins": "Atividade (12 intervalos)",
    "streamingOutput": "Saída em streaming",
    "recentTools": "Ferramentas recentes",
    "finalOutput": "Saída final",
    "heading": "Monitor de agentes",
    "prevAgent": "Agente anterior",
    "nextAgent": "Próximo agente",
    "closeAria": "Fechar monitor de agentes",
    "hintPage": "←→ página",
    "hintNavigate": "↑↓ navegar lista",
    "hintEsc": "Esc fechar"
  },
  "terminal": {
    "resize": "Redimensionar terminais",
    "labelSingular": "Terminal",
    "labelPlural": "Terminais",
    "projectShell": "Shell do projeto",
    "maxTerminals": "Máximo de {{count}} terminais",
    "newTerminal": "Novo terminal",
    "restart": "Reiniciar terminal ativo",
    "closeAll": "Fechar todos os terminais",
    "closeDock": "Fechar o dock de terminal (Ctrl+`)",
    "closeTab": "Fechar {{name}}",
    "processExited": "[processo encerrado com código {{code}}]"
  },
  "sessionWatch": {
    "liveStream": "Transmissão ao vivo",
    "events_one": "{{count}} evento",
    "events_other": "{{count}} eventos",
    "interruptTitle": "Parar cooperativamente este agente em seu próximo passo (não é um kill)",
    "interrupt": "⏸ Interromper",
    "interrupting": "…",
    "loading": "Carregando sessão…",
    "done": "✓✓ concluído",
    "read": "✓ lido",
    "delivered": "⏳ entregue",
    "agent": "Agente",
    "you": "Você",
    "working": "{{name}} · trabalhando",
    "claude": "Claude",
    "priority": "Prioridade",
    "placeholder": "{{label}} → esta sessão…",
    "send": "Enviar",
    "sendHint": "⌘/Ctrl+Enter para enviar · visível na próxima iteração do agente",
    "msgType": {
      "steerLabel": "🔄 Direcionar",
      "steerHint": "Ajustar o comportamento durante a tarefa",
      "askLabel": "❓ Perguntar",
      "askHint": "Pergunta — espera resposta",
      "assignLabel": "📋 Atribuir",
      "assignHint": "Uma tarefa a realizar",
      "noteLabel": "💬 Nota",
      "noteHint": "Para informação, não urgente"
    },
    "sentRunning": "Entregue — o agente em execução verá no próximo passo",
    "sentIdle": "Entregue — o alvo está inativo; aparece em sua caixa, lido na próxima execução",
    "sentFailed": "Falhou: {{error}}",
    "interruptReason": "O operador solicitou a parada pelo Fleet HQ",
    "interruptSent": "Interrupção enviada — o agente para no próximo passo (não é um kill)",
    "interruptFailed": "Interrupção falhou: {{error}}"
  },
  "sideEffects": {
    "empty": "Nenhum efeito colateral registrado ainda.",
    "emptyHint": "Comandos bash, instalações de pacotes e requisições de rede aparecerão aqui.",
    "heading": "Efeitos colaterais",
    "exportTitle": "Exportar efeitos colaterais filtrados como CSV",
    "all": "Todos",
    "colTime": "Hora",
    "colTool": "Ferramenta",
    "colRisk": "Risco",
    "colDetail": "Detalhe",
    "colOutcome": "Resultado"
  },
  "monitor": {
    "elapsedHm": "há {{h}}h {{m}}m",
    "elapsedMs": "há {{m}}m {{s}}s",
    "elapsedS": "há {{s}}s",
    "heading": "Monitor da frota",
    "clientsHeading": "Clientes conectados",
    "terminal": "Terminal",
    "webui": "IU Web",
    "repl": "REPL",
    "totalConnected": "conectados no total",
    "mailQueue": "Fila de correio",
    "total": "Total",
    "open": "Abertos",
    "unread": "Não lidos",
    "agents": "Agentes",
    "messagesSub": "mensagens",
    "uncompletedSub": "não concluídos",
    "waitingSub": "aguardando",
    "ofTotal": "de {{count}} no total",
    "agentRoster": "Lista de agentes",
    "liveMailActivity": "Atividade de e-mail ao vivo",
    "noActivity": "Sem atividade recente",
    "mailboxAgents": "Agentes da caixa",
    "noMailboxAgents": "Nenhum agente registrado",
    "moreCount": "+{{count}} mais",
    "agentFallback": "agente",
    "fleetAgents": "Agentes da frota",
    "noFleetAgents": "Nenhum agente da frota em execução",
    "iter": "iter.",
    "mailType": {
      "sent": "Enviado",
      "delivered": "Entregue",
      "read": "Lido",
      "completed": "Concluído"
    }
  },
  "sdd": {
    "status": {
      "pending": "pendente",
      "queued": "em fila",
      "in_progress": "em execução",
      "blocked": "bloqueado",
      "review": "revisão",
      "failed": "falhou",
      "completed": "concluído",
      "cancelled": "cancelado"
    },
    "activityHeading": "Atividade",
    "feedEmpty": "Ainda nada — os eventos aparecem aqui conforme os agentes pegam e concluem tarefas.",
    "destroyTitle": "Destruir o projeto SDD?",
    "destroyDesc": "Isto apaga o run e seu trabalho. Não pode ser desfeito (o revert opcional preserva o histórico).",
    "stopRun": "Parar o run",
    "stopRunAgents_one": "Parar o run ({{count}} agente ativo)",
    "stopRunAgents_other": "Parar o run ({{count}} agentes ativos)",
    "removeWorktreesAll": "Remover todos os worktrees git + ramos wstack/ap/* — incluindo trabalho não mergedado",
    "removeWorktreesCount_one": "Remover {{count}} worktree git + ramos wstack/ap/* — incluindo trabalho não mergedado",
    "removeWorktreesCount_other": "Remover {{count}} worktrees git + ramos wstack/ap/* — incluindo trabalho não mergedado",
    "deleteArtifacts": "Excluir todos os artefatos SDD (specs, grafo de tarefas, board, sessão)",
    "revertMerged_one": "Reverter também {{count}} commit mergedado",
    "revertMerged_other": "Reverter também {{count}} commits mergedados",
    "revertHint": "Adiciona commits de revert (histórico preservado). Recusado se a árvore de trabalho estiver suja.",
    "baseBranchFallback": "o ramo base",
    "noteLeaveMerged": "Os commits mergedados ficarão no ramo base. Marque a caixa acima para desfazê-los também.",
    "noteAbandon": "Certifique-se de que realmente quer abandonar este run.",
    "destroying": "Destruindo…",
    "destroyAll": "Destruir tudo",
    "kanbanBacklog": "Backlog",
    "kanbanReady": "Pronto",
    "kanbanRunning": "Em execução",
    "kanbanReview": "Revisão",
    "kanbanFailed": "Falhou",
    "kanbanDone": "Concluído",
    "kanbanEmpty": "vazio"
  },
  "toolResult": {
    "collapseToLines": "Recolher para as primeiras {{count}} linhas",
    "showAllLines": "Mostrar todas as {{total}} linhas ({{more}} a mais)",
    "exitCode": "código de saída:",
    "jsonLines": "JSON · {{count}} linhas",
    "collapse": "recolher",
    "expand": "expandir"
  },
  "design": {
    "heading": "Design Studio — Galeria",
    "kitsCount": "{{count}} kits",
    "searchPlaceholder": "Pesquisar kits…",
    "stackTitle": "Stack para Use + Materialize",
    "wrote": "{{path}} escrito",
    "materializeFailed": "Materialize falhou: {{error}}",
    "verifyError": "Verificar: {{error}}",
    "verifyOffPalette": "Verificar: {{pct}}% na paleta — {{count}} fora da paleta em {{files}} arquivo(s)",
    "verifyClean": "Verificar: limpo ✓ ({{files}} arquivo(s) na paleta)",
    "writing": "Escrevendo arquivo de tema…",
    "scanning": "Verificando arquivos de UI…",
    "active": "Ativo",
    "reapply": "Reaplicar",
    "use": "Usar",
    "materializeTitle": "Gravar tokens em um arquivo de tema {{stack}}",
    "materialize": "Materializar",
    "verifyTitle": "Verificar arquivos de UI em busca de cores fora da paleta",
    "verify": "Verificar",
    "colors": "Cores"
  },
  "autoPhase": {
    "summary_one": "{{count}} fase · {{pct}}% concluído",
    "summary_other": "{{count}} fases · {{pct}}% concluído",
    "switchBoard": "Trocar painel",
    "boardsCount_one": "{{count}} painel…",
    "boardsCount_other": "{{count}} painéis…",
    "toggleAutonomousTitle": "Alternar modo autônomo",
    "autonomous": "Autônomo",
    "manual": "Manual",
    "resumeTitle": "Retomar a execução",
    "pauseTitle": "Pausar a execução",
    "resume": "Retomar",
    "pause": "Pausar",
    "stopTitle": "Parar a execução — aborta agentes em andamento imediatamente",
    "stop": "Parar",
    "newTitle": "Limpar este painel e iniciar uma nova execução AutoPhase",
    "newLabel": "Novo",
    "revertConfirm": "Reverter os commits da execução?",
    "revertTitle": "Desfazer esta execução — git-revert dos commits feitos e remover worktrees",
    "revert": "Reverter",
    "goal": "Objetivo",
    "planning": "Planejando fases…",
    "planningBody": "Seu objetivo foi recebido. O WrongStack está dividindo-o em fases e tarefas — o painel aparece aqui assim que o plano estiver pronto.",
    "startHeading": "Iniciar um plano de fases",
    "startBody": "Descreva o que você quer construir. O WrongStack planejará fases e tarefas, depois as executará — observe e direcione a execução no painel.",
    "startPlaceholder": "ex. Crie uma API REST de gerenciamento de usuários com Express e SQLite...",
    "isolateLabel": "Isolar cada fase em seu próprio worktree git",
    "startButton": "Iniciar AutoPhase",
    "ctrlHint": "Ctrl+Enter para iniciar",
    "isolateOn": "as fases rodam em worktrees isolados, com squash-merge de volta",
    "isolateOff": "as fases rodam diretamente no branch atual",
    "lanes": "Faixas",
    "graph": "Grafo",
    "planningAck": "🚀 **AutoPhase** — entendido. Planejando fases para seu objetivo…"
  },
  "collab": {
    "noObservers": "Sem observadores ao vivo",
    "observerTitle": "Entrar como observador somente leitura (Fase 1)",
    "observerRole": "observador",
    "annotatorTitle": "Entrar como anotador — deixe notas nas chamadas (Fase 2)",
    "annotatorRole": "anotador",
    "controllerTitle": "Entrar como controlador — pode pausar o agente (Fase 3)",
    "controllerRole": "controlador",
    "errorPrefix": "Collab: {{error}}",
    "dismiss": "fechar",
    "observers_one": "{{count}} observador",
    "observers_other": "{{count}} observadores",
    "annotationsTitle": "{{count}} anotação(ões) aberta(s) — anotadores revisando",
    "notes_one": "{{count}} nota",
    "notes_other": "{{count}} notas",
    "pausedTitle": "Agente em pausa — um controlador está revisando",
    "paused": "em pausa",
    "joinedTitle": "Entrou {{time}}",
    "grantTitle": "Ceder controle — promover este participante a controlador",
    "injectTitle": "Injetar um resultado sintético para uma chamada em andamento",
    "inject": "Injetar",
    "resumeTitle": "Retomar o agente",
    "resume": "Retomar",
    "pauseTitle": "Pausar o agente antes da próxima chamada",
    "pauseAgent": "Pausar agente",
    "leaveTitle": "Sair da sessão de observação",
    "leave": "Sair",
    "injectToolResult": "Injetar resultado",
    "close": "fechar",
    "targetTool": "id tool_use alvo",
    "targetPlaceholder": "escolha uma chamada em andamento ou digite um id tool_use",
    "toolFallback": "ferramenta",
    "noPendingTools": "Sem chamadas em andamento — digite um id tool_use ou pause o agente primeiro.",
    "resultContent": "Conteúdo do resultado",
    "resultPlaceholder": "Resultado sintético fornecido ao agente em vez de executar a ferramenta",
    "markError": "marcar como erro",
    "reasonPlaceholder": "motivo (log de auditoria)",
    "queueInjection": "Enfileirar injeção",
    "controllerInjection": "injeção controlador"
  },
  "connection": {
    "reconnecting": "Reconectando ao backend (tentativa {{attempt}}) — tentando novamente em {{remaining}} s",
    "disconnected": "Desconectado do backend",
    "retry": "Tentar novamente",
    "retryTitle": "Tentar conexão novamente agora",
    "dismissTitle": "Fechar (o chip na barra superior ainda mostra o status)"
  },
  "mode": {
    "modePrefix": "modo:",
    "activeTitle": "Modo ativo",
    "heading": "Modo",
    "defaultName": "Padrão",
    "defaultDesc": "Comportamento padrão do agente"
  },
  "cost": {
    "clickTitle": "Clique para o detalhamento de custo por turno",
    "heading": "Detalhamento de custos",
    "noPricing": "Sem precificação para o modelo atual — os valores de custo são zero.",
    "noTurns": "Nenhum turno concluído ainda. Execute um prompt para ver o custo por turno aqui.",
    "topExpensive_one": "Turno mais caro",
    "topExpensive_other": "Os {{count}} turnos mais caros"
  },
  "model": {
    "runDefault": "Padrão do run",
    "useRunDefault": "Usar padrão do run",
    "filterPlaceholder": "Filtrar modelos…",
    "loading": "Carregando modelos…",
    "noMatch": "Sem correspondência"
  },
  "modelSwitcher": {
    "filterPlaceholder": "Filtrar provedores e modelos…",
    "noSavedProviders": "Sem provedores salvos — registre uma chave nas Configurações primeiro.",
    "active": "ativo"
  },
  "work": {
    "todos": "A fazer",
    "tasks": "Tarefas",
    "plan": "Plano"
  },
  "todos": {
    "toggleAria": "Alternar: {{content}}",
    "removeTitle": "Remover tarefa",
    "removeAria": "Remover \"{{content}}\"",
    "completedCount_one": "{{count}} concluída",
    "completedCount_other": "{{count}} concluídas"
  },
  "task": {
    "start": "Iniciar",
    "complete": "Concluir",
    "retry": "Tentar novamente",
    "assign": "Atribuir",
    "assignTitle": "Atribuir agente",
    "unassigned": "Não atribuído",
    "statusPending": "Pendente",
    "statusInProgress": "Em andamento",
    "statusBlocked": "Bloqueado",
    "statusFailed": "Falhou",
    "statusReview": "Revisão",
    "statusDone": "Concluído",
    "startTitle": "Iniciar",
    "completeTitle": "Concluir",
    "fail": "Falhar",
    "failTitle": "Marcar como falha",
    "boardCount": "{{total}} tarefas · {{done}} concluídas"
  },
  "toolGroup": {
    "toolCalls_one": "{{count}} chamada",
    "toolCalls_other": "{{count}} chamadas"
  },
  "fileRef": {
    "removeTitle": "Remover referência",
    "linesCount_one": "{{count}} linha",
    "linesCount_other": "{{count}} linhas"
  },
  "plan": {
    "statusOpen": "Aberto",
    "statusInProgress": "Em andamento",
    "statusDone": "Concluído",
    "startTitle": "Iniciar",
    "doneTitle": "Marcar como concluído",
    "reopenTitle": "Reabrir",
    "reopen": "Reabrir"
  },
  "filePicker": {
    "heading": "@ Arquivos",
    "noMatch": "Nenhum arquivo corresponde a \"{{query}}\"",
    "searching": "Pesquisando no projeto…"
  },
  "toast": {
    "dismiss": "Dispensar"
  },
  "search": {
    "placeholder": "Pesquisar no chat…",
    "prevHit": "Resultado anterior",
    "nextHit": "Próximo resultado",
    "close": "Fechar (Esc)"
  },
  "phase": {
    "statusPending": "Pendente",
    "statusReady": "Pronto",
    "statusRunning": "Em execução",
    "statusPaused": "Em pausa",
    "statusCompleted": "Concluído",
    "statusFailed": "Falhou",
    "statusSkipped": "Ignorado",
    "heading": "Fases",
    "autonomousOn": "● Autônomo",
    "autonomousOff": "○ Manual",
    "autonomousOnTitle": "Modo autônomo ativo — clique para pausar",
    "autonomousOffTitle": "Modo manual — clique para ativar o autônomo",
    "overallProgress": "Progresso geral",
    "tasksSuffix": "{{done}}/{{total}} tarefas",
    "agentsSuffix_one": "{{count}} agente",
    "agentsSuffix_other": "{{count}} agentes"
  },
  "ctxMode": {
    "triggerTitle": "Modo de janela de contexto",
    "ctxPrefix": "ctx:",
    "opsHeading": "Operações de contexto",
    "compactNow": "Compactar agora",
    "compactNowDesc": "Omitir saída de ferramenta antiga",
    "compactAggressive": "Compactação agressiva",
    "compactAggressiveDesc": "Omissão máxima agora",
    "repairContext": "Reparar contexto",
    "repairDesc": "Corrigir blocos tool-use órfãos",
    "debugContext": "Depurar contexto",
    "debugDesc": "Detalhamento de tamanho por seção",
    "windowHeading": "Janela de contexto",
    "keepElide": "manter {{k}} recentes · omitir {{t}}+ tokens",
    "fallbackName": "Equilibrado",
    "fallbackDesc": "Compactação rolling padrão"
  },
  "transcript": {
    "kindAssistant": "Assistente",
    "kindThinking": "Pensamento",
    "kindToolCall": "Chamada de ferramenta",
    "kindToolResult": "Resultado de ferramenta",
    "kindError": "Erro",
    "kindStatus": "Status",
    "kindSystem": "Sistema",
    "title": "Histórico do chat",
    "copyTitle": "Copiar histórico de chat do agente",
    "empty": "Ainda não há histórico de chat para este agente."
  },
  "autonomy": {
    "heading": "Modo de autonomia",
    "titlePrefix": "Autonomia: {{label}}",
    "descOff": "Controle manual total — o agente espera sua entrada.",
    "descSuggest": "O agente sugere os próximos passos mas aguarda aprovação.",
    "descAuto": "O agente prossegue automaticamente após um breve atraso de confirmação.",
    "descEternal": "O agente executa de forma autônoma até o objetivo ser concluído.",
    "descEternalParallel": "Execução autônoma multi-agente — modo frota."
  },
  "queue": {
    "heading": "Fila de mensagens",
    "subtitle": "{{count}} na fila · mensagens enviadas antes do agente terminar",
    "btwTitle": "A propósito — enviado como acompanhamento sem interromper o agente em execução",
    "steerTitle": "Guiar — interrompe o agente em execução e o redireciona com esta mensagem",
    "queueTitle": "Na fila — retido até o run do agente terminar, depois enviado em ordem",
    "sortNewestTitle": "Ordenado do mais recente — clique para ordenar do mais antigo",
    "sortOldestTitle": "Ordenado do mais antigo — clique para ordenar do mais recente",
    "newest": "Mais recente",
    "oldest": "Mais antigo",
    "clear": "Limpar",
    "clearTitle": "Limpar todas as mensagens da fila",
    "closeTitle": "Fechar",
    "emptyTitle": "A fila está vazia",
    "emptyBody": "Use os botões btw / steer / adicionar à fila ao lado da entrada para adicionar mensagens. Os itens na fila são enviados em ordem quando o run do agente termina.",
    "removeTitle": "Remover da fila",
    "footer": "As mensagens são enviadas em ordem de chegada quando o run do agente termina. Use a ordenação para ver as mais recentes primeiro."
  },
  "checkpoint": {
    "heading": "Pontos de controle da sessão",
    "countSuffix_one": "{{count}} ponto de controle",
    "countSuffix_other": "{{count}} pontos de controle",
    "description": "Rebobine a sessão para qualquer ponto de controle. Mensagens e alterações de arquivo revertem para aquele ponto — o LLM continua de lá como se nada tivesse acontecido depois.",
    "emptyTitle": "Ainda não há pontos de controle",
    "emptyBody": "Pontos de controle são criados automaticamente a cada mensagem enviada. Envie algumas mensagens e volte.",
    "latest": "recente",
    "msgSuffix_one": "{{count}} msg",
    "msgSuffix_other": "{{count}} msgs",
    "footerPre": "Clique em qualquer ponto de controle para rebobinar",
    "footerPost": "para fechar"
  },
  "goal": {
    "statusActive": "Ativo",
    "statusPaused": "Em pausa",
    "statusDone": "Concluído",
    "statusFailed": "Falhou",
    "statusAbandoned": "Abandonado",
    "heading": "Objetivo",
    "refined": "Refinado",
    "progress": "Progresso",
    "iterations": "iterações",
    "deliverables": "Entregáveis",
    "recentActivity": "Atividade recente"
  },
  "worktree": {
    "cleanTitle_one": "Limpar {{count}} worktree órfão?",
    "cleanTitle_other": "Limpar {{count}} worktrees órfãos?",
    "cleanMessage": "Remove forçadamente cada worktree git + ramo wstack/ap deixado por runs anteriores. O trabalho não mergedado neles é descartado.",
    "cleanConfirm": "Limpar órfãos",
    "orphanCount_one": "{{count}} worktree órfão de runs anteriores",
    "orphanCount_other": "{{count}} worktrees órfãos de runs anteriores",
    "andMore": "…e mais {{count}}",
    "cleanButtonTitle": "Remover forçadamente todos os worktrees + ramos órfãos",
    "removed_one": "✓ {{count}} worktree órfão removido.",
    "removed_other": "✓ {{count}} worktrees órfãos removidos.",
    "cleanupFailed": "limpeza falhou",
    "lanesHeading": "Worktrees",
    "base": "base",
    "isolatedCount_one": "{{count}} isolado",
    "isolatedCount_other": "{{count}} isolados",
    "statusAllocating": "alocando",
    "statusActive": "ativo",
    "statusCommitting": "commitando",
    "statusMerging": "mergendo",
    "statusMerged": "mergado",
    "statusConflict": "conflito",
    "statusFailed": "falhou",
    "conflictBadge": "CONFLITO",
    "graphAria": "Grafo de ramos worktree a partir de {{base}}",
    "mergedLabel": "✓ mergedo → {{base}}"
  },
  "process": {
    "heading": "Processos em execução",
    "subtitle": "{{active}} ativos · {{total}} total",
    "killAll": "Matar todos",
    "emptyTitle": "Nenhum processo rastreado",
    "emptyBody": "Os processos aparecem aqui quando o agente executa ferramentas bash ou exec. Processos ativos mostram um LED pulsante.",
    "pidLabel": "PID {{pid}}",
    "protected": "protegido",
    "protectedTitle": "Protegido — sobrevive a kill/killAll",
    "killTitle": "Matar PID {{pid}}"
  },
  "diff": {
    "tooLarge": "Diff omitido (arquivo grande demais para renderizar em linha)."
  },
  "fallback": {
    "placeholder": "Adicionar modelo de fallback…",
    "emptyHint": "Tentados em ordem quando o modelo primário é limitado ou trava.",
    "moveUp": "Mover para cima",
    "moveDown": "Mover para baixo",
    "manualPlaceholder": "provedor/modelo",
    "addTitle": "Adicionar referência de modelo"
  },
  "liveSessions": {
    "loading": "Carregando sessões...",
    "apiUnavailable": "API de sessão indisponível:",
    "empty": "Nenhuma sessão ativa. Abra outra instância wstack para vê-la aqui.",
    "heading": "Sessões ativas ({{count}})",
    "autoRefresh": "atualização automática a cada 5 s",
    "pidLabel": "PID {{pid}}",
    "agentMeta": "{{iter}} iterações · {{tools}} ferramentas · {{ago}}",
    "andMore": "... e mais {{count}}",
    "noAgents": "Nenhum agente"
  },
  "monacoDiff": {
    "applyTitle": "Escrever a versão editada no disco",
    "applying": "Aplicando…",
    "applied": "Aplicado",
    "apply": "Aplicar"
  },
  "errorBody": {
    "showStack_one": "Mostrar rastreamento de pilha ({{count}} quadro)",
    "showStack_other": "Mostrar rastreamento de pilha ({{count}} quadros)",
    "hideStack_one": "Ocultar rastreamento de pilha ({{count}} quadro)",
    "hideStack_other": "Ocultar rastreamento de pilha ({{count}} quadros)"
  },
  "officeMap": {
    "liveHeading": "Ao vivo",
    "clients": "Clientes",
    "agents": "Agentes",
    "model": "Modelo",
    "mode": "Modo",
    "toolCalls": "Chamadas",
    "displayHeading": "Exibição",
    "statsHud": "HUD de stats",
    "legends": "Legendas",
    "minimap": "Minimapa",
    "zoomControls": "Controles de zoom",
    "animateWires": "Animar fios",
    "backgroundHeading": "Fundo",
    "bgDots": "Pontos",
    "bgLines": "Linhas",
    "bgCross": "Cruz",
    "bgNone": "Nenhum"
  },
  "toolInput": {
    "noParams": "(sem parâmetros)",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} itens",
    "keyCount_one": "{{count}} chave",
    "keyCount_other": "{{count}} chaves"
  },
  "message": {
    "roleYou": "Você",
    "roleTool": "Ferramenta",
    "roleThinking": "Pensamento",
    "roleAssistant": "Assistente",
    "inputLabel": "Entrada",
    "downloadTitle": "Baixar como arquivo",
    "empty": "(vazio)",
    "hideDetails": "Ocultar detalhes",
    "showDetails": "Mostrar detalhes",
    "showDetailsLines_one": "Mostrar detalhes ({{count}} linha)",
    "showDetailsLines_other": "Mostrar detalhes ({{count}} linhas)",
    "editHint": "⌘/Ctrl+Enter para salvar · Esc para cancelar",
    "saveResend": "Salvar e reenviar",
    "thinkingProcess": "Processo de pensamento",
    "thinkingMeta": "iter {{iter}} · {{dur}} · {{lines}}",
    "replay": "repetição",
    "linesSuffix_one": "{{count}} linha",
    "linesSuffix_other": "{{count}} linhas",
    "copyLog": "Copiar registro",
    "showFullLog": "Mostrar registro completo",
    "typing": "Digitando…",
    "noContent": "Sem conteúdo",
    "failedToSend": "⚠ Falha ao enviar",
    "autoPaused": "⚠️ _Avanço automático pausado — máximo de turnos automáticos consecutivos atingido. Digite algo para continuar (a autonomia permanece ativa)._",
    "rsIterations": "Iterações: {{n}}",
    "rsTools": "Chamadas: {{n}}",
    "rsElapsed": "Decorrido: {{s}}",
    "rsCost": "Custo: {{c}}",
    "useInput": "Entrada: {{n}}",
    "useOutput": "Saída: {{n}}",
    "useCacheRead": "Leitura cache: {{n}}",
    "useCost": "Custo: {{c}}",
    "renderedLabel": "Renderizado",
    "rawLabel": "Bruto",
    "showRenderedTitle": "Mostrar markdown renderizado",
    "showRawTitle": "Mostrar fonte markdown bruta",
    "editTitle": "Editar e reenviar este prompt",
    "editLabel": "Editar",
    "unpinTitle": "Desafixar",
    "pinTitle": "Fixar esta resposta",
    "pinnedLabel": "Fixado",
    "pinLabel": "Fixar",
    "regenerateTitle": "Regenerar esta resposta",
    "retryLabel": "Tentar novamente"
  },
  "watch": {
    "toolFallback": "ferramenta",
    "toolFailed": "Ferramenta falhou"
  },
  "shortcuts": {
    "heading": "Atalhos de teclado",
    "footerPre": "Pressione",
    "footerPost": "a qualquer momento para reabrir esta lista.",
    "sectionGlobal": "Global",
    "sectionTuiParity": "Paridade de painel TUI",
    "sectionFleet": "Frota e agentes",
    "sectionChatInput": "Entrada do chat",
    "sectionChat": "Chat",
    "sectionChatNav": "Navegação do chat (sem digitar)",
    "dCommandPalette": "Abrir paleta de comandos",
    "dShowOverlay": "Mostrar este overlay de atalhos",
    "dToggleSidebar": "Alternar barra lateral",
    "dOpenPanel": "Abrir painel lateral (Sessão, Agentes, Histórico, Arquivos, Mudanças, Caixa, Skills, Office Map)",
    "dDesignStudio": "Abrir painel do Design Studio",
    "dWorktrees": "Abrir painel de Worktrees",
    "dFocusInput": "Focar a entrada de mensagens",
    "dSessionPanel": "Painel de sessão",
    "dFleetOverlay": "Overlay do monitor de frota",
    "dAgentsOverlay": "Overlay do monitor de agentes",
    "dWorktreeMonitor": "Monitor de worktrees",
    "dPlanPanel": "Painel de plano",
    "dTodosPanel": "Painel de tarefas",
    "dQueuePanel": "Painel de fila",
    "dProcessMonitor": "Monitor de processos",
    "dGoalPanel": "Painel de objetivo",
    "dSessionsDashboard": "Painel de sessões",
    "dOfficeMap": "Office map do coordenador",
    "dDockPicker": "Seletor de chips do dock",
    "dOpenFleet": "Abrir overlay do monitor de frota",
    "dOpenAgents": "Abrir overlay do monitor de agentes",
    "dNavigateAgents": "Navegar agentes no monitor",
    "dSelectAgent": "Selecionar agente focado",
    "dCloseOverlay": "Fechar overlay ativo",
    "dSendMessage": "Enviar mensagem",
    "dNewline": "Inserir nova linha",
    "dRecallPrev": "Relembrar prompt anterior (entrada vazia)",
    "dRecallNext": "Relembrar próximo prompt",
    "dSlashPopup": "Abrir popup de comandos slash",
    "dAutocomplete": "Autocompletar comando destacado",
    "dDismissPopup": "Fechar popup / limpar entrada",
    "dSearchChat": "Pesquisar no chat atual",
    "dClearContext": "Limpar contexto (igual a /clear)",
    "dNewSession": "Iniciar nova sessão (igual a /new)",
    "dExportMarkdown": "Exportar chat como markdown",
    "dModelSwitcher": "Overlay seletor rápido de modelo",
    "dCompactDensity": "Alternar densidade UI compacta",
    "dAbortRun": "Abortar o run atual (durante execução)",
    "dFocusNext": "Focar próxima mensagem (atalho: ↓)",
    "dFocusPrev": "Focar mensagem anterior (atalho: ↑)",
    "dJumpFirst": "Ir para a primeira mensagem",
    "dJumpLast": "Ir para a última mensagem",
    "dCopyFocused": "Copiar texto da mensagem focada",
    "dClearFocused": "Limpar mensagem focada"
  },
  "sddBoard": {
    "titleFallback": "Board SDD ao vivo",
    "defaultModelTitle": "Modelo worker padrão do run (overrides por tarefa têm precedência)",
    "graphLabel": "Grafo",
    "kanbanLabel": "Kanban",
    "retryAllTitle": "Recolocar cada tarefa falha em pending",
    "retryFailed": "Re tentar falhas ({{count}})",
    "resume": "Retomar",
    "pause": "Pausar",
    "stop": "Parar",
    "cleanTitle": "Remover os worktrees git + ramos wstack/ap do run",
    "cleanWorktrees": "Limpar worktrees",
    "rollbackTitle": "Reverter {{count}} commit(s) mergedado(s) em {{base}}",
    "rollback": "Rollback ({{count}})",
    "stopping": "Parando…",
    "destroying": "Destruindo…",
    "destroyTitle": "Parar, remover todos os worktrees, reverter opcionalmente commits mergedados e excluir o projeto SDD",
    "destroy": "Destruir",
    "statDone": "feitos",
    "statRunning": "em execução",
    "statFailed": "falhas",
    "statWave": "onda",
    "statElapsed": "decorrido",
    "noActiveWorkers": "sem workers ativos",
    "deadlock": "Impasse — tarefas bloqueadas por trabalho falho:",
    "noRunTitle": "Sem run SDD ativo.",
    "noRunBody": "Inicie um pelo assistente New SDD Project ou via /sdd execute na CLI — os agentes aparecem aqui ao vivo, cada num worktree isolado.",
    "clickTaskHint": "clique numa tarefa para detalhes",
    "lcClean": "Limpeza",
    "lcRollback": "Rollback",
    "lcDestroy": "Destruição",
    "lcFailed": "{{op}} falhou: {{reason}}",
    "lcUnknownError": "erro desconhecido",
    "lcWorktrees_one": "{{count}} worktree removido",
    "lcWorktrees_other": "{{count}} worktrees removidos",
    "lcCommits_one": "{{count}} commit revertido",
    "lcCommits_other": "{{count}} commits revertidos",
    "lcDeleted": "excluído {{items}}",
    "lcNothing": "nada a fazer",
    "lcNote": "{{op}}: {{body}} — nota: {{reason}}",
    "lcOk": "{{op}}: {{body}}"
  },
  "sddTask": {
    "backTitle": "Voltar à atividade",
    "workingOn": "trabalhando nesta tarefa",
    "assigned": "atribuído",
    "metaPriority": "Prioridade",
    "metaType": "Tipo",
    "metaDuration": "Duração",
    "metaElapsed": "Decorrido",
    "metaRetries": "Tentativas",
    "metaWorktree": "Worktree",
    "workerModel": "Modelo worker",
    "runDefault": "padrão do run: {{model}}",
    "runDefaultPlaceholder": "Padrão do run",
    "runDefaultPlaceholderModel": "Padrão do run ({{model}})",
    "verificationCmd": "Comando de verificação",
    "gatesCompletion": "valida a conclusão (exit 0)",
    "verifyPlaceholder": "ex. pnpm vitest run path/to/file",
    "addVerify": "+ Adicionar comando de verificação",
    "description": "Descrição",
    "timeline": "Linha do tempo",
    "dependsOn": "Depende de",
    "blocks": "Bloqueia",
    "newWorkerPlaceholder": "Nome do novo worker…",
    "confirmStop": "Parar esta tarefa em execução?",
    "confirmDelete": "Excluir esta tarefa do run?",
    "retryTitle": "Recolocar esta tarefa em pending",
    "reassign": "Reatribuir",
    "stopTitle": "Abortar o worker nesta tarefa",
    "splitTitle": "Dividir esta tarefa em subtarefas delegadas a workers separados",
    "split": "Dividir",
    "splitHint": "Uma subtarefa por linha — Título :: descrição (descrição opcional)",
    "splitPlaceholder": "Escreva a camada de dados :: adicione o repositório\nConecte a UI",
    "splitInto": "Dividir em subtarefas",
    "deleteTitle": "Remover esta tarefa não iniciada do run"
  },
  "sddWizard": {
    "phaseStart": "Iniciar",
    "phaseInterview": "Entrevista",
    "phaseSpecReview": "Revisão spec",
    "phasePlanning": "Planejamento",
    "phaseTaskReview": "Revisão tarefas",
    "phaseRunning": "Em execução",
    "phaseDone": "Concluído",
    "titleFallback": "Novo projeto SDD",
    "questionsSuffix": "{{cur}}/{{max}} perguntas",
    "tasksSuffix": "{{count}} tarefas",
    "runCfgTitle": "Config do run — modelo padrão + cadeia de fallback",
    "modelsLabel": "Modelos",
    "startRun": "Iniciar run",
    "defaultWorkerModel": "Modelo worker padrão",
    "leaderDefaultPlaceholder": "Leader / padrão da sessão",
    "useSessionDefault": "Usar padrão da sessão",
    "fallbackChain": "Cadeia de fallback",
    "appliesToAll": "Aplica-se a cada tarefa. Override por tarefa no board live após iniciar.",
    "parallelAgents": "Agentes paralelos",
    "isolateWorktrees": "Isolar em worktrees git",
    "worktreeOn": "Cada tarefa roda no seu próprio worktree, squash-mergedo ao concluir.",
    "worktreeOff": "As tarefas rodam diretamente no ramo atual (sem isolamento).",
    "goalPrompt": "O que você quer construir?",
    "goalPlaceholder": "ex. Adicionar login OAuth (Google + GitHub) com gestão de sessão",
    "startingInterview": "Iniciando entrevista…",
    "startInterview": "Iniciar entrevista",
    "introBody": "Um agente isolado entrevista você para construir uma spec, a decompõe num grafo de tarefas ordenado por dependências, depois uma frota multi-agente real a executa — acompanhe ao vivo no board.",
    "taskGraphSummary": "Grafo de tarefas · {{count}} tarefas, ordenadas por dependências",
    "dragToExplore": "arraste para explorar",
    "show": "mostrar",
    "goalLabel": "Objetivo",
    "implementationPlan": "Plano de implementação",
    "approveSpec": "Aprovar spec → planejar implementação",
    "approveTasks": "Aprovar tarefas",
    "approvePlan": "Aprovar plano",
    "answerPlaceholder": "Responda à pergunta…",
    "changePlaceholder": "Pedir uma mudança…"
  },
  "fileExplorer": {
    "emptyDir": "vazio",
    "loadFailed": "Falha ao carregar arquivos: {{error}}",
    "expandAllTitle": "Expandir todas as pastas",
    "expandAll": "Expandir tudo",
    "collapseAllTitle": "Recolher todas as pastas",
    "collapse": "Recolher",
    "folders_one": "{{count}} pasta",
    "folders_other": "{{count}} pastas",
    "currentDirTitle": "Diretório atual: {{path}}",
    "navigateToTitle": "Navegar para {{path}}",
    "filesSuffix_one": "{{count}} arquivo",
    "filesSuffix_other": "{{count}} arquivos",
    "goToDir": "ir ao diretório",
    "navigateParentTitle": "Navegar ao diretório pai de {{path}}",
    "parentDirectory": "diretório pai",
    "noFiles": "Nenhum arquivo encontrado",
    "copyAbsPath": "Copiar caminho absoluto",
    "copyRelPath": "Copiar caminho relativo",
    "openInTerminal": "Abrir no terminal",
    "openInFileManager": "Abrir no gerenciador de arquivos",
    "mentionInChat": "Mencionar no chat",
    "copyPath": "Copiar caminho"
  },
  "codeEditor": {
    "sendSelectionAction": "Enviar seleção para o chat",
    "noFilesOpen": "Nenhum arquivo aberto",
    "selectToEdit": "Selecione um arquivo do explorador para editar",
    "sendSelectedTitle": "Enviar linhas selecionadas ao chat",
    "mentionFileTitle": "Mencionar este arquivo no chat",
    "sendToChat": "Enviar ao chat",
    "mentionFile": "Mencionar arquivo",
    "loadingEditor": "Carregando editor…",
    "selectTab": "Selecione uma aba para ver o conteúdo"
  },
  "analytics": {
    "loading": "Carregando analytics…",
    "heading": "Painel de analytics",
    "autoRefresh": "atualização a cada 10 s",
    "liveSessions": "Sessões ao vivo",
    "agents": "Agentes",
    "agentsActive": "{{count}} ativos",
    "totalEvents": "Eventos totais",
    "categoriesSub": "{{count}} categorias",
    "toolCalls": "Chamadas",
    "iterationsSub": "{{count}} iterações",
    "sessionCost": "Custo da sessão",
    "tokensSub": "{{input}} entrada / {{output}} saída",
    "sessionDuration": "Duração da sessão",
    "messagesSub": "{{count}} mensagens",
    "eventsByCategory": "Eventos por categoria",
    "noEvents": "Nenhum evento registrado.",
    "topEvents": "Principais eventos",
    "activeSessionUsage": "Uso da sessão ativa",
    "provider": "Provedor",
    "model": "Modelo",
    "inputTokens": "Tokens de entrada",
    "outputTokens": "Tokens de saída",
    "cacheRatio": "Proporção de cache",
    "filesRead": "Arquivos lidos",
    "noSession": "Sem sessão ativa ou aguardando dados…",
    "healthErrors": "Saúde e erros",
    "errorEvents": "Eventos de erro",
    "warningEvents": "Eventos de aviso",
    "cacheHitRate": "Taxa de acerto de cache",
    "totalCategories": "Categorias totais",
    "waitingData": "Aguardando dados…",
    "recentEvents": "Eventos recentes",
    "noRecentEvents": "Sem eventos recentes. Interaja com a UI para gerar eventos."
  },
  "promptLib": {
    "searchPlaceholder": "Pesquisar prompts…",
    "newPrompt": "＋ Novo prompt",
    "all": "Todos",
    "recent": "🕘 Recentes",
    "favorites": "★ Favoritos",
    "noMatch": "Nenhum prompt corresponde.",
    "newPromptHeading": "Novo prompt",
    "titlePlaceholder": "Título *",
    "descPlaceholder": "Descrição de uma linha",
    "categoryPlaceholder": "Categoria",
    "tagsPlaceholder": "tags, separadas, por vírgula",
    "contentPlaceholder": "Conteúdo do prompt * — use {{name}} para variáveis",
    "variables": "Variáveis",
    "addVar": "＋ var",
    "varNamePlaceholder": "nome",
    "varDescPlaceholder": "descrição",
    "removeVarTitle": "Remover variável",
    "required": "obrigatório",
    "multiline": "multilinha",
    "enumPlaceholder": "enum: a, b, c",
    "savePrompt": "Salvar prompt",
    "saveFailed": "Não foi possível salvar o prompt.",
    "titleContentRequired": "Título e conteúdo são obrigatórios.",
    "toggleFavoriteTitle": "Alternar favorito",
    "selectOption": "— escolher —",
    "fillMissing": "Preencher: {{missing}}",
    "insertIntoChat": "Inserir no chat",
    "selectPromptHint": "Selecione um prompt para pré-visualizar e inserir."
  },
  "skillDetail": {
    "scopeProject": "Projeto",
    "scopeGlobal": "Global",
    "scopeBundled": "Embutido",
    "timeoutError": "Tempo limite da requisição. Tente novamente.",
    "updateFailed": "Atualização falhou",
    "saveFailed": "Salvamento falhou",
    "uninstallFailed": "Desinstalação falhou",
    "noSkillSelected": "Nenhuma habilidade selecionada",
    "selectSkillHint": "Selecione uma habilidade da barra lateral para ver sua documentação",
    "goToChat": "Ir ao chat",
    "openSourceRepo": "Abrir repo de origem",
    "copySourceUrl": "Copiar URL de origem",
    "updatedLabel": "↑ Atualizado: {{list}}",
    "upToDateLabel": "— Atualizado: {{list}}",
    "errorsLabel": "✗ {{list}}",
    "checkUpdatesTitle": "Verificar atualizações",
    "exportTitle": "Exportar habilidade como .md",
    "editTitle": "Editar habilidade",
    "uninstallTitle": "Desinstalar habilidade",
    "closeTitle": "Fechar e ir ao chat",
    "backTitle": "Voltar",
    "forwardTitle": "Avançar",
    "relatedFiles": "Arquivos relacionados",
    "references": "Referências",
    "goToSkillTitle": "Ir para {{name}}",
    "loadingContent": "Carregando conteúdo…",
    "editingLabel": "Editando {{name}}",
    "editStats": "{{lines}} linhas · {{words}} palavras · {{chars}} caracteres",
    "charsWarningFmt": "⚠ {{used}} MB / {{limit}} MB",
    "draftSaved": "Rascunho salvo",
    "draftRestored": "Rascunho restaurado",
    "discardDraft": "Descartar rascunho",
    "splitViewTitle": "Vista dividida",
    "hidePreviewTitle": "Ocultar pré-visualização",
    "contentPlaceholder": "Conteúdo da habilidade (markdown)...",
    "loadFailed": "Falha ao carregar o conteúdo",
    "noContent": "Sem conteúdo disponível",
    "uninstallSkillHeading": "Desinstalar habilidade",
    "uninstallConfirm": "Desinstalar {{name}}?",
    "uninstallRemovePath": "Isso removerá a habilidade de {{path}} e não pode ser desfeito.",
    "uninstallAction": "Desinstalar"
  },
  "office": {
    "sessionStats": "Estatísticas da sessão",
    "clients": "Clientes",
    "input": "Entrada",
    "output": "Saída",
    "cost": "Custo",
    "agentsSuffix": "agentes",
    "upPrefix": "ativo há {{time}}",
    "webuiClient": "Cliente WebUI",
    "disconnected": "Desconectado",
    "connected": "Conectado",
    "tuiClient": "Cliente TUI",
    "terminal": "Terminal",
    "repl": "REPL",
    "coordinator": "COORDENADOR",
    "fleetSummary": "Resumo da frota",
    "toolCallsLabel": "Chamadas",
    "tokensLabel": "Tokens",
    "coordinatingFleet": "Coordenando frota",
    "donePrefix": "✓ concluído ·",
    "failedPrefix": "✕ falhou ·",
    "seenPrefix": "visto há {{time}}",
    "availableDesk": "Mesa disponível",
    "mailboxHub": "Central de correio",
    "unreadSuffix_one": "{{count}} não lida",
    "unreadSuffix_other": "{{count}} não lidas",
    "allClear": "Tudo lido",
    "total": "Total",
    "unreadLabel": "Não lidas",
    "liveActivity": "Atividade ao vivo",
    "waitingActivity": "Aguardando atividade…",
    "now": "agora",
    "fleetHq": "QG da Frota WrongStack",
    "live": "AO VIVO",
    "legendStatus": "Status",
    "legendActive": "Ativo",
    "legendIdle": "Inativo",
    "legendError": "Erro",
    "legendConnections": "Conexões",
    "legendMail": "Correio",
    "legendTask": "Tarefa",
    "legendStatusConn": "Status",
    "arrange": "Organizar",
    "arrangeTitle": "Retornar nós à planta",
    "feed": "Feed",
    "feedTitle": "Alternar feed de atividade ao vivo",
    "broadcast": "Transmitir",
    "broadcastTitle": "Transmitir mensagem a cada sessão ao vivo do projeto",
    "broadcastToAll": "Transmitir a todas as sessões",
    "broadcastPlaceholder": "Mensagem a cada agente ao vivo do projeto…",
    "broadcastSendHint": "⌘/Ctrl+Enter para enviar",
    "openFullView": "Abrir visualização completa de operações",
    "rowStatus": "Status",
    "rowModel": "Modelo",
    "rowTool": "Ferramenta",
    "rowIterations": "Iterações",
    "rowToolCalls": "Chamadas",
    "rowTokensIn": "Tokens de entrada",
    "rowTokensOut": "Tokens de saída",
    "rowTokensTotal": "Tokens totais",
    "rowContext": "Contexto",
    "rowCost": "Custo",
    "rowLastSeen": "Visto pela última vez",
    "rowSurface": "Superfície",
    "rowBranch": "Ramo",
    "rowPid": "PID",
    "rowDir": "Dir.",
    "rowAgents": "Agentes",
    "rowUptime": "Tempo ativo",
    "rowConnections": "Conexões",
    "rowTotalMessages": "Mensagens totais",
    "rowUnread": "Não lidas",
    "recent": "Recentes",
    "noSubject": "(sem assunto)",
    "fullOperationStream": "Fluxo completo de operações",
    "closeEsc": "Fechar (Esc)",
    "idleDesk": "Mesa inativa",
    "fleetHqLabel": "QG da Frota",
    "clientsSuffix_one": "{{count}} cliente",
    "clientsSuffix_other": "{{count}} clientes",
    "taskFallback": "tarefa",
    "controlLabel": "controle"
  },
  "skillsList": {
    "installTitle": "Instalar habilidade",
    "createTitle": "Criar habilidade",
    "exportTitle": "Exportar todas as habilidades como .zip",
    "checkUpdatesTitle": "Verificar atualizações (todas)",
    "searchPlaceholder": "Pesquisar habilidades…",
    "loading": "Carregando…",
    "noSkills": "Sem habilidades instaladas",
    "noMatch": "Nenhuma habilidade corresponde ao filtro",
    "noDescription": "Sem descrição",
    "scopeForeign": "Externa",
    "installHeading": "Instalar Habilidade",
    "installHint": "Insira uma referência de repo GitHub (owner/repo) ou URL completa.",
    "installPlaceholder": "ex. wrongstack/skill-name ou https://github.com/owner/repo",
    "installScope": "Escopo de instalação:",
    "installBtn": "Instalar",
    "installedMsg": "Instalada: {{names}}",
    "installFailed": "Instalação falhou",
    "createHeading": "Criar Habilidade",
    "createHint": "Scaffold uma nova habilidade. A primeira linha é o trigger.",
    "nameLabel": "Nome",
    "namePlaceholder": "ex. minha-nova-habilidade",
    "descLabel": "Descrição / Trigger",
    "descPlaceholder": "Use esta habilidade quando <situação>.\nTriggers: o usuário diz \"palavra-chave\", \"outra\".",
    "saveIn": "Salvar em:",
    "createBtn": "Criar Habilidade",
    "createdMsg": "Criada: {{name}}",
    "createFailed": "Criação falhou"
  },
  "timeline": {
    "noEvents": "Sem eventos."
  },
  "designStudio": {
    "pickHint": "Escolha um kit — o agente vai segui-lo.",
    "gallery": "Galeria",
    "galleryTitle": "Abrir galeria de pré-visualização ao vivo",
    "stackTitle": "Stack alvo",
    "loading": "Carregando kits…",
    "notFound": "Nenhum kit de design encontrado.",
    "bestFor": "Ideal para:",
    "light": "Claro",
    "dark": "Escuro"
  },
  "worktrees": {
    "detached": "(separado)",
    "count_one": "{{count}} worktree",
    "count_other": "{{count}} worktrees",
    "baseSuffix": " · base {{base}}",
    "baseLabel": "base",
    "cleanOrphans": "Limpar órfãos",
    "cleanOrphansTitle": "Remover todos os worktrees órfãos",
    "liveBusyTitle": "Um run está ativo — pare-o primeiro",
    "rescanTitle": "Re-escanear",
    "removed_one": "Removido {{count}} worktree.",
    "removed_other": "Removidos {{count}} worktrees.",
    "failed": "Falhou",
    "mergedIntoBase": "{{branch}} mesclado na base.",
    "conflictMerge": "Conflito ao mesclar {{branch}}: {{files}}",
    "seeGit": "ver git",
    "mergeFailed": "Mesclagem falhou: {{reason}}",
    "unknownReason": "desconhecido",
    "mergeConfirmTitle": "Mesclar {{branch}} em {{base}}?",
    "mergeConfirmMsg": "Squash-mescla este branch no branch base. Cancela limpo em caso de conflito.",
    "mergeAction": "Mesclar",
    "removeConfirmTitle": "Remover {{branch}}?",
    "removeConfirmMsg": "Remove forçadamente o checkout do worktree e exclui seu branch. Trabalho não mesclado é descartado.",
    "empty": "Sem worktrees.",
    "emptyHint": "Runs SDD / AutoPhase criam worktrees isolados aqui. Órfãos de runs falhos também aparecem.",
    "actOpenTerm": "Abrir no terminal",
    "actOpenFolder": "Abrir pasta",
    "actViewChanges": "Ver alterações",
    "actMerge": "Mesclar na base",
    "actRemove": "Remover / descartar",
    "live": "ativo",
    "noUncommitted": "Sem alterações não confirmadas",
    "commitsAhead_one": "{{count}} commit à frente",
    "commitsAhead_other": "{{count}} commits à frente",
    "more": "…{{count}} mais"
  },
  "officeSettings": {
    "heading": "Mapa do Escritório",
    "headingHint": "Visualize sua frota como uma planta de escritório com status dos agentes ao vivo.",
    "statAgents": "Agentes",
    "statMail": "Correio",
    "unreadSuffix": " não lidos",
    "sectionView": "Visualização",
    "sectionDisplay": "Exibição",
    "sectionBackground": "Fundo",
    "sectionRecent": "Atividade Recente",
    "eventsTrackedSuffix": " eventos rastreados",
    "recentHint": "Envios de correio, spawns de agentes e mudanças de status aparecem aqui.",
    "sectionShortcuts": "Atalhos",
    "sectionLegend": "Legenda",
    "hudLabel": "HUD",
    "hudDesc": "Mostrar overlay de estatísticas de sessão em tempo real",
    "hudToggle": "Ativar HUD",
    "minimapLabel": "Minimapa",
    "minimapDesc": "Mostrar o minimapa de visão geral",
    "minimapToggle": "Ativar minimapa",
    "controlsLabel": "Controles",
    "controlsDesc": "Mostrar controles de zoom e ajuste",
    "controlsToggle": "Ativar controles",
    "animateLabel": "Animar arestas",
    "animateDesc": "Animar o fluxo nas conexões ativas",
    "animateToggle": "Ativar animação de arestas",
    "legendLabel": "Mostrar legenda",
    "legendDesc": "Exibir legenda de status e conexão",
    "legendToggle": "Ativar legenda",
    "feedLabel": "Feed ao vivo",
    "feedDesc": "Faixa inferior de atividade recente entre processos",
    "feedToggle": "Ativar feed ao vivo",
    "fitView": "Ajustar",
    "zoomIn": "Ampliar",
    "zoomOut": "Reduzir",
    "resetZoom": "Redefinir zoom",
    "legendActive": "Ativo (em execução)",
    "legendIdle": "Inativo",
    "legendError": "Erro",
    "legendOffline": "Offline",
    "bg": {
      "dots": "Pontos",
      "lines": "Linhas",
      "cross": "Cruz",
      "none": "Nenhum"
    }
  }
}
